/* eslint-disable import/prefer-default-export */
export const infoType = {
  EVENT: 'EVENT',
  PREDICT_EVENT: 'PREDICT_EVENT',
  CHANGE_CONFIG: 'CHANGE_CONFIG',
  REGULAR_CHECK: 'REGULAR_CHECK',
  PLANNDED_WORK: 'PLANNDED_WORK',
  CHANGE_WORK: 'CHANGE_WORK',
  MESSAGE: 'MESSAGE',
  NOTICE: 'NOTICE',
  CHANGE_TOPOLOGYMAP: 'CHANGE_TOPOLOGYMAP',
};



// WEBPACK FOOTER //
// ./src/constants/push-notification.js